import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { usePageMeta } from '@/shared/lib/context/page-meta-context'
import { useAuth } from '@/shared/lib/auth/auth-context'
import { isPaypagaTenant } from '@/shared/lib/auth/tenant-constants'

export function DemoBanner() {
  const { t } = useTranslation()
  const meta = usePageMeta()
  const { user } = useAuth()

  if (!meta?.demo) return null

  const messageKey = isPaypagaTenant(user) ? 'demoBanner.sandboxMessage' : 'demoBanner.message'

  return (
    <div className="sticky top-24 z-30 flex items-center justify-center gap-2 bg-amber-300/40 px-4 py-1.5 text-sm font-medium text-amber-800 dark:bg-amber-500/20 dark:text-amber-300">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>{t(messageKey)}</span>
    </div>
  )
}
